import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { BotRegistrationService } from "src/app/services/core/bot-registration/bot-registration.service";
import { ToastrService } from "ngx-toastr";
import { ToasterService } from "../../../services/shared/toaster/toaster.service";
import { Router, NavigationStart, RouterEvent } from "@angular/router";
import { UserService } from "src/app/services/core/user/user.service";
import { filter } from "rxjs/operators";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { TokenService } from "src/app/services/core/token/token.service";
import { FileuploadService } from "src/app/services/shared/fileupload/fileupload.service";

@Component({
  selector: "app-warning-popup",
  templateUrl: "./warning-popup.component.html",
  styleUrls: ["./warning-popup.component.scss"],
})
export class WarningPopupComponent implements OnInit {
  public confirmClicked: boolean;
  public warningFor: string;
  _routerSubscription: any;
  public fromConversation: boolean = false;
  userRoles: string[];
  public isAgent: boolean = false;
  public allTerminationMessages: any;
  public isSeniorAgent: boolean = false;
  terminationReasonDetails: any;
  terminationReasonForm: FormGroup;
  terminationReason: FormControl;
  constructor(
    private dialogRef: MatDialogRef<WarningPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private botService: BotRegistrationService,
    private userService: UserService,
    private fileuploadService:FileuploadService,
    private toasterService: ToasterService,
    private router: Router,
    private tokenService: TokenService
  ) {
    this.confirmClicked = false;
  }

  ngOnInit() {
    this._routerSubscription = this.router.events
      .pipe(
        filter((event: RouterEvent) => event instanceof NavigationStart),
        filter(() => !!this.dialogRef)
      )
      .subscribe(() => {
        this.dialogRef.close();
      });
    if (this.data == "expiredToken") this.warningFor = "expiredToken";
    else if (this.data.chatStatus == "endChat") {
      this.warningFor = "endChat";
      this.getAllTerminationMsg(this.data.botConfigId);
    } else if (this.data.chatStatus == "leaveChat")
      this.warningFor = "leaveChat";
    else if (this.data.data.storageId) this.warningFor = "deleteFileFromBlob";
    else if (this.data == "connectionClosed")
      this.warningFor = "connectionClosed";
    else if (this.data.data.botRegistrationId)
      this.warningFor = "deleteBotRegistration";
    else if (this.data.data.firstName) this.warningFor = "deleteUser";
    else this.warningFor = "deleteUserRole";

    if (sessionStorage.getItem("lastActiveTab") == "conversation") {
      this.fromConversation = true;
    }

    this.userRoles = sessionStorage.getItem("userRoles")
      ? sessionStorage.getItem("userRoles").split(",")
      : [];
    let agent = this.userRoles.find((ob) => ob.toLowerCase() === "agent");
    let seniorAgent = this.userRoles.find(
      (ob) =>
        ob.toLowerCase() === "senioragent" ||
        ob.toLowerCase() === "senior agent"
    );
    if (agent) this.isAgent = true;
    if (seniorAgent) this.isSeniorAgent = true;

    this.terminationReason = new FormControl("", Validators.required);
    this.terminationReasonForm = new FormGroup({
      terminationReason: this.terminationReason,
    });
  }
  onCloseCancel() {
    this.dialogRef.close("CANCEL");
    if (this.data == "expiredToken")
      this.router.navigate(["/conversations/hilconversations"]);
  }

  getAllTerminationMsg(botConfigId: number) {
    this.userService.getTerminationMsg(botConfigId).subscribe(
      (res) => {
        this.allTerminationMessages = res;
      },
      (error) => {
        console.log("Error in Termination getAllTerminationMsg: ");
        console.log(error);
        if (error != "Internal Server Error") this.getRefreshToken();
        else
          this.toasterService.error("Unable to retrieve termination messages");
      }
    );
  }

  getRefreshToken() {
    console.log("GetRefreshToken called for Termination Reason");
    this.tokenService.getRefreshToken().subscribe(
      (res) => {
        let objToken = res;
        localStorage.setItem("accessToken", objToken.token);
        localStorage.setItem("refreshToken", objToken.refreshToken);
        this.getAllTerminationMsg(this.data.botConfigId);
      },
      (error) => {
        console.log("Error in Termination GetRefreshToken:");
        console.log(error);
      }
    );
  }

  onConfirmOk() {
    this.confirmClicked = true;
    if (typeof this.data == "string") {
      if (this.data == "expiredToken" || this.data == "connectionClosed") {
        this.dialogRef.close("CONFIRM");
        //this.router.navigate(["/"]);
        window.location.href = "/";
      }
    } else if (typeof this.data.chatStatus == "string") {
      if (this.data.chatStatus == "endChat") {
        localStorage.setItem("endChat", "true");
        //ToDo: change hardcode value with selected termination reason
        localStorage.setItem("terminationReason", "termination reason 1");
        this.dialogRef.close("CONFIRM");
      } else if (this.data.chatStatus == "leaveChat") {
        localStorage.setItem("leaveChat", "true");
        this.dialogRef.close("CONFIRM");
      }
    } else {
      if (this.data.data.botRegistrationId) {
        this.botService.deleteBotRegistration(this.data).subscribe(
          (data) => {
            this.dialogRef.close("CONFIRM");
            this.toasterService.warn("Successfully deleted Bot Registration");
          },
          (error) => {
            this.dialogRef.close("CONFIRM");
            this.toasterService.error(
              "Error occured while deleting Bot Registration"
            );
          }
        );
      } else if (this.data.data.firstName) {
        this.userService.deleteUser(this.data).subscribe(
          (data) => {
            this.dialogRef.close("CONFIRM");
            this.toasterService.warn("Successfully deleted User");
          },
          (error) => {
            this.dialogRef.close("CONFIRM");
            this.toasterService.error("Error occured while deleting User");
          }
        );
      } 
      else if (this.data.data.storageId) {
        this.fileuploadService.DeleteFile(this.data.data.storageId).subscribe(
          (data) => {
            this.dialogRef.close("CONFIRM");
            this.toasterService.success("File deleted successfully");
          },
          (error) => {
            this.dialogRef.close("CONFIRM");
            this.toasterService.error("Error occured while deleting File");
          }
        );
      }
      
      else {
        this.userService.deleteUserRole(this.data.data).subscribe(
          (res) => {
            this.dialogRef.close("CONFIRM");
            this.toasterService.success("Successfully deleted User role");
          },
          (error) => {
            this.dialogRef.close("CONFIRM");
            this.toasterService.error("Error Occured while deleting User role");
          }
        );
      }
    }
  }

  saveTerminationReason(formValues) {
    localStorage.setItem("endChat", "true");
    //ToDo: change hardcode value with selected termination reason
    localStorage.setItem("terminationReason", formValues.terminationReason);
    this.dialogRef.close("CONFIRM");
  }
}
